<template>
  <div class="text-xs-center">
    <v-dialog
      v-model="isVisible"
      max-width="500"
    >
      <v-card>
        <v-card-title
          class="headline text-md-center"
          primary-title
        >
          Upload Tax Calculation CSV
        </v-card-title>

        <v-card-text light>
          <p><strong>Payout</strong>: <code>{{ payout.description }}</code></p>
          <p><strong>Payout ID</strong>: <code>{{ payout.payout_id }}</code></p>
          <p><v-divider /></p>
          <v-btn
            :color="validFile !== null ? 'green' : 'primary'"
            @click="pickFile"
          >
            Choose CSV
            <v-icon
              v-if="validFile !== null"
              right
            >
              check
            </v-icon>
          </v-btn>
          <input
            ref="image"
            type="file"
            style="display: none"
            :accept="csvFormats"
            @change="CSVChanged"
          >
          <p
            v-for="(error, index) in validationErrors"
            :key="index"
            class="red--text"
          >
            {{ error }}
          </p>
        </v-card-text>

        <v-divider />

        <v-card-actions>
          <v-spacer />
          <v-btn
            color="secondary"
            flat
            @click="() => { isVisible = false; }"
          >
            Cancel
          </v-btn>
          <v-btn
            color="primary"
            flat
            :disabled="validFile === null"
            @click="() => { $emit('fileUpload', validFile); isVisible = false; }"
          >
            Upload
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Papa from 'papaparse';

export default {
  name: 'TaxCalculationUploadCSVDialog',
  components: {
  },
  props: {
    visible: Boolean,
    payout: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      csvFormats: '.csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel',
      validFile: null,
      validationErrors: [],
    };
  },
  computed: {
    isVisible: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.validationErrors = [];
          this.validFile = null;
          this.$emit('close');
          this.$refs.image.value = null;
        }
      },
    },
  },
  methods: {
    pickFile() {
      this.$refs.image.click();
    },
    CSVChanged(event) {
      this.validationErrors = [];
      this.validFile = null;
      const file = event.currentTarget.files[0];
      if (!file) {
        return;
      }
      const reader = new FileReader();
      reader.readAsText(file, 'UTF-8');
      reader.onload = (readerEvent) => {
        const errors = this.validateCSV(readerEvent.target.result);
        if (errors.length === 0) {
          this.validFile = file;
        } else {
          this.validationErrors = errors;
        }
      };
      reader.onerror = () => {
        this.validationErrors = ['Could not read CSV file.'];
      };
    },
    validateCSV(data) {
      try {
        const csvData = Papa.parse(data);
        if (csvData.errors.length > 0) {
          return csvData.errors;
        }

        if (csvData.data.length <= 1) {
          return ['CSV does not contain any data.'];
        }

        return [];
      } catch (error) {
        return ['Could not parse CSV File.'];
      }
    },
  },
};
</script>
<style lang="scss" />



// WEBPACK FOOTER //
// src/components/payoutsAndTaxes/payout/dialogs/payout/TaxCalculationUploadCSVDialog.vue